@if (title) {
  <div class="container">
    <h1 class="page__title">{{ title }}</h1>
  </div>
}
